module.exports = __webpack_public_path__ + "assets/img/Updating.ce7c6120.svg";